module.exports = __webpack_public_path__ + "img/LinkedIn.6732b24c.png";